import * as requestFromServer from "./reviewsApis";
import Actions from "../../actions";

// reviews -> get super admin reviews list api
export const getReviewsAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.getReviews(dataToBeSent);
    if (response) {
      dispatch(
        Actions.createAction(Actions.GET_REVIEWS_LIST, { reviews: response })
      );
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// reviews -> get service provider reviews list api
export const getServiceProviderReviewsAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.getServiceProviderReviews(
      dataToBeSent
    );
    if (response) {
      dispatch(
        Actions.createAction(Actions.GET_SERVICE_PROVIDER_REVIEWS_LIST, {
          reviews: response,
        })
      );
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

export const getReviewByIdAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.getReviewById(dataToBeSent);
    if (response) {
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

export const sendServiceProviderReview =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.addProviderAdminReview(
      dataToBeSent
    );
    if (response) {
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

export const addSuperAdminReviewAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.addSuperAdminReview(dataToBeSent);
    if (response) {
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };
